import * as XLSX from "xlsx";

/** One worksheet (tab) of a workbook, as CSV text. */
export type SheetCsv = { name: string; csv: string };

/** True when the file name ends in a spreadsheet extension (.xlsx / .xls). */
export function isSpreadsheetFileName(name: string): boolean {
  return /\.(xlsx|xls)$/i.test(name ?? "");
}

/** Read an Excel workbook buffer and return every worksheet (tab) as CSV text, in tab order. */
export function spreadsheetBufferToSheets(buffer: ArrayBuffer): SheetCsv[] {
  const data = new Uint8Array(buffer);
  // sheet_to_csv always emits each cell's cached value (.w/.v), never the formula source, so an
  // imported formula like =1+1 comes through as "2". cellFormula:false just drops the raw .f field.
  // NOTE: this does NOT sanitise CSV injection — a text cell whose value starts with = + - @ is
  // emitted verbatim, so any re-export must escape those leading characters itself.
  const workbook = XLSX.read(data, { type: "array", cellFormula: false, cellText: true });
  return workbook.SheetNames.map((name) => ({
    name,
    csv: XLSX.utils.sheet_to_csv(workbook.Sheets[name]),
  }));
}

/** Read an Excel workbook buffer and return its first sheet as CSV text. */
export function spreadsheetBufferToCsv(buffer: ArrayBuffer): string {
  return spreadsheetBufferToSheets(buffer)[0]?.csv ?? "";
}
